import { useQuery } from "react-query";

import axios from "axios";
import { nuclearn_api_url } from "src/App";

export const getProducts = () => {
  return axios.get(nuclearn_api_url + "/products/").then((response) => {
    return response.data;
  });
};

export const useProducts = () => {
  return useQuery(["getProducts"], () => getProducts(), {
    refetchOnWindowFocus: false,
  });
};
